export const data = {
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Добро пожаловать",
    Main_Nav_HelpfulLinks: "Полезные ссылки",
    Main_Nav_LogOut: "Выйти",
    Main_Nav_HelpfulLinks_LI_s1: "Связаться с медсестрой моего(-их) ученика(-ов)",
    Main_Nav_HelpfulLinks_LI_s2: "Академические календари",
    Main_Nav_HelpfulLinks_LI_s3: "Ресурсы для родителей",
    Main_Nav_HelpfulLinks_LI_s4: "Маршруты автобусов",
    Main_Nav_HelpfulLinks_LI_s5: "Онлайн-платежи",
    Main_Nav_HelpfulLinks_LI_s6: "Меню обедов",
    Main_Nav_Exit: "ВЫХОД",
    Main_Nav_Tagline: "Учись сегодня. Веди завтра.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Добавить",
    Global_Close: "Закрыть",
    Global_Completed: "Завершено",
    Global_InProgress: "В процессе",
    Global_GoTo: "Перейти к",
    Global_MoreInfo: "Подробнее",
    Global_NotStarted: "Не начато",
    Global_Open: "Открыто",
    Global_OpenFrom: "Открыто с ", // [DATE] - [DATE]
    Global_Status: "Статус",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Финансовая прозрачность DCSD",
    Breadcrumb_Translations: "Переводы экспериментальные",
    /// /////////////////////////////////////////////////////////
    /// //////////////// Main ///////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Instruction: (
        <ul>
            <li>
                Этот инструмент позволяет общественности искать и экспортировать информацию о финансовых расходах DCSD
                по состоянию на 1 июля 2017 года.
            </li>
            <li>
                Просмотрите{" "}
                <a
                    href="https://www.dcsdk12.org/about/departments/business-services/budget-and-accounting"
                    rel="noreferrer"
                    target="_blank"
                >
                    План счетов
                </a>
                , применимый к транзакциям DCSD, в разделе &ldquo;Ресурсы&rdquo;.
            </li>
            <li>
                Пожалуйста, учитывайте контекст при оценке финансовых операций. Мы приветствуем ваши вопросы
                относительно наших финансовых операций или записей.
            </li>
        </ul>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////// Faceted Search //////////////////////////
    /// /////////////////////////////////////////////////////////
    Facet_Keyword: "Введите Ключевое Слово Здесь",
    Facet_Export: "Экспорт CSV",
    Facet_Search: "Поиск",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Forms /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Fiscal_Year: "финансовый год",
    Fiscal_Year_Instruction: (
        <h5>
            您希望查看哪个<b>财政年度</b>？
        </h5>
    ),
    Quarter_Instruction: (
        <>
            <h5>
                Какой <b>квартал</b> вы хотели бы просмотреть?
            </h5>
            <p>
                Выберите один из доступных кварталов финансового года, чтобы сгенерировать первоначальный набор
                результатов. Будущие кварталы выбрать нельзя.
            </p>
        </>
    ),
    Quarter_View: "Просмотр",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Results ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    Results_Title: "Результаты поиска",
    Results_Instruction:
        "Результаты поиска перечислены ниже. Результаты поиска могут быть дополнительно уточнены по фонду, местоположению, типу платежа и категории расходов. Пользователи также могут использовать поиск по ключевым словам, чтобы найти конкретную информацию о расходах в отфильтрованных результатах. Результаты поиска можно экспортировать (формат .csv), нажав кнопку «Экспорт CSV».",
    Results_No_Results: "Платежей Не Найдено"
};
